export default __webpack_public_path__ + "static/media/ELIKSIR-00371.38548de8.JPG";